import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, CanActivateChild, Router, RouterStateSnapshot } from '@angular/router';

import { StateService } from '../services/state/state.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate, CanActivateChild {
  constructor(
    private readonly stateService: StateService,
    private readonly router: Router
  ) {}

  public canActivate(_route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    return this.checkAuthentication(state.url);
  }

  public canActivateChild(_childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    return this.checkAuthentication(state.url);
  }

  private checkAuthentication(url: string): boolean {
    const isAuthenticated = this.stateService.isUserLoggedIn();

    if (isAuthenticated) {
      return true;
    }

    void this.router.navigate(['/login'], {
      queryParams: { redirect: url },
    });

    return false;
  }
}
